<ng-container *transloco="let t">
  <div class="flex h-screen flex-1 flex-col overflow-hidden">
    <header class="sticky top-0 flex flex-col">
      <div class="flex w-full min-w-0 flex-1 items-center justify-between px-4">
        <div class="flex h-14 items-center justify-center p-2">
          <app-logo class="block h-full"></app-logo>
        </div>
        <button
          iButton
          [iTooltip]="t('dashboard360-layout.logout')"
          variant="ghost"
          size="icon-sm"
          testId="logout-button"
          (click)="logout()"
        >
          <IIcon name="logout" />
        </button>
      </div>
    </header>
    <div class="flex flex-1 justify-center overflow-auto pb-10">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
